/** Minimal query for `generateMetadata` (title only). */
export const GET_ADVISORY_SEO_METADATA_QUERY = `query page($path: String, $limit: Int = 10, $offset: Int = 0, $search: String) {
  advisoriesGraphql(path: $path, limit: $limit, offset: $offset, search: $search, order: "-") {
    count
    entities {
      title
    }
  }
}`

export const GET_ADVISORYDETAIL_QUERY = `query page($path: String, $limit: Int = 10, $offset: Int = 0, $search: String) {
  advisoriesGraphql(path: $path, limit: $limit, offset: $offset, search: $search, order: "-") {
    count
    entities {
      nid
      title
      fieldDate {
        value
      }
      path {
        alias
      }
      fieldPageParagraph {
        entity {
          fieldReusableParagraphs {
            entity {
              fieldWysiwygModContent {
                value
              }
            }
          }
        }
      }
    }
  }
}`
